module.exports = __webpack_public_path__ + "img/lupa.97b2b372.svg";